/**
 * This file lists the FontAwesome icons that are registered and imported
 * with the Vue container.
 */

import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faCube,
	faTachometerAlt,
	faChartLine,
	faUserShield,
	faGlobeAmericas,
	faBuilding,
	faCaretRight,
	faCaretDown,
	faSignOutAlt,
	faPencilAlt,
	faTimes,
	faAngleLeft,
	faFilter,
	faLink,
	faColumns,
	faCaretSquareRight,
	faCaretSquareLeft,
	faLayerGroup,
	faSquare,
	faCheckSquare,
	faArchive,
	faLevelUpAlt,
	faPlus,
	faAlignJustify,
	faEnvelope,
	faEnvelopeOpen,
	faCalendar,
	faSync,
	faClock,
	faStickyNote,
	faCog,
	faClipboardCheck,
	faEye,
	faSearch,
	faArrowRight,
	faExclamation,
	faEllipsisV,
	faQuestionCircle,
	faBan,
	faExclamationCircle,
	faInfoCircle,
	faServer,
	faDesktop,
	faUsers,
	faExclamationTriangle,
	faBars,
	faUserTag,
	faArrowUpRightFromSquare
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
	faCube,
	faTachometerAlt,
	faChartLine,
	faUserShield,
	faGlobeAmericas,
	faBuilding,
	faCaretDown,
	faCaretRight,
	faSignOutAlt,
	faPencilAlt,
	faTimes,
	faAngleLeft,
	faFilter,
	faLink,
	faColumns,
	faCaretSquareRight,
	faCaretSquareLeft,
	faLayerGroup,
	faSquare,
	faCheckSquare,
	faArchive,
	faLevelUpAlt,
	faPlus,
	faAlignJustify,
	faEnvelope,
	faEnvelopeOpen,
	faCalendar,
	faSync,
	faClock,
	faStickyNote,
	faCog,
	faClipboardCheck,
	faEye,
	faSearch,
	faArrowRight,
	faExclamation,
	faEllipsisV,
	faQuestionCircle,
	faBan,
	faExclamationCircle,
	faInfoCircle,
	faServer,
	faDesktop,
	faUsers,
	faExclamationTriangle,
	faBars,
	faUserTag,
	faArrowUpRightFromSquare
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
